/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_Step_5Inputs */

const en_claims_step_5 = /** @type {(inputs: Claims_Step_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick the box ‘statement on authorization’.`)
};

const fr_claims_step_5 = /** @type {(inputs: Claims_Step_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cochez la case 'déclaration d'autorisation'.`)
};

/**
* | output |
* | --- |
* | "Tick the box ‘statement on authorization’." |
*
* @param {Claims_Step_5Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_step_5 = /** @type {((inputs?: Claims_Step_5Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_Step_5Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_step_5(inputs)
	return fr_claims_step_5(inputs)
});